import './Error404.scss'

import {BlockType, Blocks} from '../blocks/Blocks'
import {useLanguage, useTranslation} from '../../util/i18n'

import {HeroType} from '../layout/Hero'
import {Layout} from '../layout/Layout'
import {PageData} from '../../types'
import React from 'react'
import {Theme} from '../Theme'
import {style} from '../../util/style'
import {wrap} from '@codeurs/front'

const styles = style('error', ['default'])

type Error404Type = {
	hero: HeroType
	blocks?: Array<BlockType>
}

export const Error404: React.FC<PageData & Error404Type> = wrap(Layout)(
	({...props}) => {
		const {hero, blocks} = props

		return (
			<div className={styles()}>
				<Error404Default {...hero} />
				<Blocks blocks={blocks} container={true} />
			</div>
		)
	}
)

const Error404Default = ({title, text, link}) => {
	const language = useLanguage()
	const t = useTranslation('error404')

	return (
		<div className={styles.default()}>
			<Theme.Container>
				<div className={styles.default('content')}>
					<Theme.H1 className={styles.default('content-title')}>
						{title || t.title}
					</Theme.H1>
					<div className={styles.default('content-text')}>
						<Theme.Wysiwyg>{text || t.text}</Theme.Wysiwyg>
					</div>
					<div className={styles.default('content-button')}>
						{link && link.url && (
							<Theme.Button to={link.url}>
								{link.description || link.title}
							</Theme.Button>
						)}
						{!link && <Theme.Button to="/">{t.btnlabel}</Theme.Button>}
					</div>
				</div>
			</Theme.Container>
		</div>
	)
}
